const GameState = {
    playerXWins: 0,
    playerOWins: 1,
    draw: 2,
    inProgress: 3,
  };
  
  export default GameState;